export default __webpack_public_path__ + "static/realWorldImg1-73aac93935cc6b5e068cb02fb6cf65ed.webp";